import { BaseTypeSchema } from "../BaseTypeSchema";
import { VariableType } from "../VariableType";

export class IPV6Schema extends BaseTypeSchema
{
    static REGEX: RegExp = /^(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$|^(?:(?::[0-9a-fA-F]{1,4}){1,6})?::(?:(?:[0-9a-fA-F]{1,4}:){0,6}[0-9a-fA-F]{1,4})?$/;
    constructor(required: boolean)
    {
        super(VariableType.IPV6, required);
    }
}